'use strict';

var defaultTheme = require('./defaultTheme-ea44e34a.js');
var React = require('react');
var styled = require('styled-components');
var TippyTooltip = require('@tippyjs/react');
require('./shift-away-subtle-0bed9a3c.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);
var TippyTooltip__default = /*#__PURE__*/_interopDefaultLegacy(TippyTooltip);

var _templateObject;
var Tooltip$1 = styled__default['default'](TippyTooltip__default['default']).attrs(defaultTheme.applyDefaultTheme)(_templateObject || (_templateObject = defaultTheme._taggedTemplateLiteral(["\n  font-family: ", ";\n  font-size: 1rem;\n  font-weight: 400;\n  background: ", ";\n  border-radius: 3px;\n  pointer-events: default !important;\n  .tippy-content {\n    padding: 9px 12px;\n  }\n\n  .tippy-arrow {\n    color: ", ";\n  }\n\n  a {\n    color: inherit;\n  }\n"])), function (props) {
  return props.theme.primaryFontFamily;
}, function (props) {
  return props.theme.getColor('gray-700');
}, function (props) {
  return props.theme.getColor('gray-700');
});

var Tooltip = React__default['default'].forwardRef(function Tooltip(_ref, ref) {
  var content = _ref.content,
      interactive = _ref.interactive,
      placement = _ref.placement,
      duration = _ref.duration,
      trigger = _ref.trigger,
      visible = _ref.visible,
      children = _ref.children,
      props = defaultTheme._objectWithoutProperties(_ref, ["content", "interactive", "placement", "duration", "trigger", "visible", "children"]);

  return React__default['default'].createElement("div", null, React__default['default'].createElement(Tooltip$1, defaultTheme._extends({
    ref: ref,
    content: content,
    interactive: interactive,
    placement: placement,
    duration: duration,
    trigger: trigger,
    visible: visible,
    animation: 'shift-away-subtle'
  }, props), children));
});
Tooltip.defaultProps = {
  content: 'Tooltip',
  interactive: false,
  placement: 'top',
  duration: 350
};
Tooltip.propTypes = process.env.NODE_ENV !== "production" ? {
  content: defaultTheme.PropTypes.oneOfType([defaultTheme.PropTypes.string, defaultTheme.PropTypes.element]).isRequired,
  interactive: defaultTheme.PropTypes.bool,
  placement: defaultTheme.PropTypes.oneOf(['top', 'top-start', 'top-end', 'right', 'right-start', 'right-end', 'bottom', 'bottom-start', 'bottom-end', 'left', 'left-start', 'left-end', 'auto', 'auto-start', 'auto-end']),
  duration: defaultTheme.PropTypes.number,
  trigger: defaultTheme.PropTypes.oneOf(['mouseenter', 'mouseenter focus', 'click', 'focusin', 'mouseenter click', '']),
  visible: defaultTheme.PropTypes.bool,
  children: defaultTheme.PropTypes.node
} : {};

exports.Tooltip = Tooltip;
